// src/components/dashboard/widgets/metric-card-widget.tsx
import { motion } from 'motion/react';

interface MetricCardWidgetProps {
  label: string;
  value: string;
  sub: string;
  dot?: boolean;
  Icon: React.ComponentType<{ size?: number; className?: string }>;
  /** Makes the card a link, e.g. to Numbers. */
  onClick?: () => void;
  linkLabel?: string;
}

export default function MetricCardWidget({ label, value, sub, dot, Icon, onClick, linkLabel }: MetricCardWidgetProps) {
  const Tag = onClick ? motion.button : motion.div;
  return (
    <Tag
      onClick={onClick}
      aria-label={onClick ? `${label}: ${value}. ${linkLabel ?? 'Open'}` : undefined}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      className={`rounded-2xl border p-4 bg-warm-gray border-leaf-500/20 h-full w-full text-left ${onClick ? 'group cursor-pointer hover:border-leaf-500/40 transition-colors' : ''}`}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="w-8 h-8 rounded-lg bg-leaf-500/10 flex items-center justify-center">
          <Icon size={15} className="text-leaf-400" />
        </div>
        <span className="text-[9px] font-bold tracking-widest text-cream-muted/50 uppercase">{label}</span>
      </div>
      <div className="text-2xl font-semibold text-cream leading-none mb-1">{value}</div>
      <div className="flex items-center gap-1.5 text-xs text-cream-muted">
        {dot && <span className="w-1.5 h-1.5 rounded-full bg-leaf-400 inline-block" />}
        <span className="truncate">{sub}</span>
        {onClick && <span className="ml-auto shrink-0 opacity-0 group-hover:opacity-100 transition-opacity text-leaf-400">{linkLabel ?? 'Open'} →</span>}
      </div>
    </Tag>
  );
}